module.exports = __webpack_public_path__ + "img/img2.d6052ba6.png";